import {
  ACTION_DELETE_SITE_TEXTS__SUCCESS,
  ACTION_DELETE_SITE_TEXTS__FAIL,
  ACTION_DELETE_SITE_TEXTS__REQUEST,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_TEXTS__REQUEST:
    case ACTION_DELETE_SITE_TEXTS__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_TEXTS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
